import { render, staticRenderFns } from "./isWeixinMark.vue?vue&type=template&id=4326cf48&scoped=true&"
import script from "./isWeixinMark.vue?vue&type=script&lang=js&"
export * from "./isWeixinMark.vue?vue&type=script&lang=js&"
import style0 from "./isWeixinMark.vue?vue&type=style&index=0&id=4326cf48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4326cf48",
  null
  
)

export default component.exports